export default "__VITE_ASSET__d3cbda9f__"